import { connect } from 'react-redux'
import PackageList from './PackageList';


const mapStateToProps = ( state ) => {
    return {
        packages : state.packageList || []
    }
};


const mapDispatchToProps = ( dispatch ) => {
    return {
        updatePackageList : ( packageFilter = null, type = null, channel = null, signature = null ) => {
            return dispatch(
                {
                    type    : 'PACKAGE_LIST_REQUESTED',
                    opts    : { packageFilter, type, channel, signature }
                }
            );
        }
    };
};


const ReduxPackageList = connect(
    mapStateToProps,
    mapDispatchToProps
)( PackageList );


export default ReduxPackageList;



// WEBPACK FOOTER //
// ./src/lib/components/PackageList/index.js